module.exports = __webpack_public_path__ + "static/media/3.35dd0cd0.png";